import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';

import { FuseConfigService } from '@fuse/services/config.service';
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';
import { FormControl, FormGroup } from '@angular/forms';
import { JmyService} from '../../../concomsis/jmy/jmy.service';
import { infoPerfilInterface } from '../../../concomsis/jmy/interfaces/services';
import { navigation } from 'app/navigation/navigation';
import { ContactsEcardComponent } from 'app/main/apps/contacts/ecard/ecard.component';
import { MatDialog } from '@angular/material/dialog';
import { ContactsService } from 'app/main/apps/contacts/contacts.service';
@Component({
    selector     : 'toolbar',
    templateUrl  : './toolbar.component.html',
    styleUrls    : ['./toolbar.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class ToolbarComponent implements OnInit, OnDestroy
{
    horizontalNavbar: boolean;
    rightNavbar: boolean;
    hiddenNavbar: boolean;
    languages: any;
    navigation: any;
    selectedLanguage: any;
    userStatusOptions: any[];
    infoPerfil:infoPerfilInterface;
    noNotificaciones:string;
    // Private
    imgLogo:string;
    private _unsubscribeAll: Subject<any>;
    dialogRef: any;
    /**
     * Constructor
     *
     * @param {FuseConfigService} _fuseConfigService
     * @param {FuseSidebarService} _fuseSidebarService
     * @param {TranslateService} _translateService
     */
    constructor(
        private _fuseConfigService: FuseConfigService,
        private _fuseSidebarService: FuseSidebarService,
        private _translateService: TranslateService,
        private jmyService: JmyService,
        
        private _matDialog: MatDialog,
        private _contactsService: ContactsService,
    )
    {
        this.imgLogo=this.jmyService.config.cliente.logo;
        this.jmyService.jmyFn.listaNotificaciones().then();
        this.jmyService.jmyFn.notificacionesListaContador.subscribe(r=>{
          //  console.log(r);
            
            this.noNotificaciones=r;
        })
        // Set the defaults
        this.userStatusOptions = [
            {
                title: 'Disponible',
                icon : 'icon-checkbox-marked-circle',
                color: '#4CAF50'
            },
            {
                title: 'Ausente',
                icon : 'icon-clock',
                color: '#FFC107'
            },
            {
                title: 'No disponible',
                icon : 'icon-minus-circle',
                color: '#F44336'
            },
            {
                title: 'Desconectado',
                icon : 'icon-checkbox-blank-circle-outline',
                color: '#616161'
            }
        ];

        this.languages = [
            {
                id   : 'es',
                title: 'Español',
                flag : 'es'
            },
           /* {
                id   : 'en',
                title: 'English',
                flag : 'us'
            },
            {
                id   : 'br',
                title: 'Turkish',
                flag : 'tr'
            }*/
        ];

        this.navigation = navigation;

        // Set the private defaults
        this._unsubscribeAll = new Subject();
        this.jmyService.jmyPerfil.perfilChange.subscribe(r=>{
            this.infoPerfil = r;
            this.infoPerfil ={...this.infoPerfil ,
                photoURL:this.infoPerfil.photoURL||jmyService.config.cliente.logo}
        })
        this.infoPerfil = {
            nombre:'...',
            email:'...',
            photoURL:'...'
        }
        this.selectedLanguage = 'es';
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------
    eCard(vista:string='ecard'): void
    {
        this.dialogRef = this._matDialog.open(ContactsEcardComponent, {
            panelClass: 'contact-form-dialog',
            data      : {
                vista: vista
            }
        });

        this.dialogRef.afterClosed()
            .subscribe((response: FormGroup) => {
                console.log(response,this.jmyService.jmyPerfil.perfil);
                
                if ( !response )
                    return; 
                else{
                    this._contactsService.guardarECard(
                        new infoPerfilInterface({...this.jmyService.jmyPerfil.perfil,
                            nombre:response.value.name,
                            email:response.value.email ||'',
                            phoneNumber:response.value.phone||'',
                            displayName:response.value.name
                        })
                    );                   
                }
            });
    }
    /**
     * On init
     */
    ngOnInit(): void
    {
        // Subscribe to the config changes
        this._fuseConfigService.config
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((settings) => {
                this.horizontalNavbar = settings.layout.navbar.position === 'top';
                this.rightNavbar = settings.layout.navbar.position === 'right';
                this.hiddenNavbar = settings.layout.navbar.hidden === true;
            });

        // Set the selected language from default languages
        this.selectedLanguage = _.find(this.languages, {id: this._translateService.currentLang});
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void
    {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Toggle sidebar open
     *
     * @param key
     */
    toggleSidebarOpen(key): void
    {
        this._fuseSidebarService.getSidebar(key).toggleOpen();
    }

    /**
     * Search
     *
     * @param value
     */
    search(value): void
    {
        // Do your search here...
        console.log(value);
    }

    /**
     * Set the language
     *
     * @param lang
     */
    setLanguage(lang): void
    {
        // Set the selected language for the toolbar
        this.selectedLanguage = lang;

        // Use the selected language for translations
        this._translateService.use(lang.id);
    }
}
